<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="apartmentTypeList"
      :items-per-page="10"
      class="elevation-1"
      :options="stateOptions"
      @update:options="onUpdate"
      :search="search"
      @click:row="onApartmentTypeClick"
    >
      <template v-slot:top>
        <v-row
          class="mb-0"
          style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)"
        >
          <v-col class="d-flex align-center">
            <v-dialog persistent v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn small class="ml-4" v-on="on">New Apartment Type</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Name"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.order"
                          label="Order"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.rooms"
                          label="Rooms"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.area"
                          label="Area"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-jsoneditor
                        v-model="editedItem.properties"
                        :plus="true"
                        height="300px"
                        :options="{
                          mode: 'code',
                          theme: 'ace/theme/tomorrow_night_bright',
                          mainMenuBar: false
                        }"
                      ></v-jsoneditor>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="2" sm="2" md="2">
            <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              outlined=""
              label="Search"
              hide-details
              class="mr-4"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.name="{ item }">
        <tr>
          {{
            item.name
          }}
        </tr>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon size="18" class="mr-2" @click="editItem(item, $event)"
          >edit</v-icon
        >
        <v-icon size="24" @click="deleteItem(item, $event)">close</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import VJsoneditor from 'v-jsoneditor/src/index'
import 'brace'
import 'brace/theme/tomorrow_night_bright'

export default {
  name: 'apartmentTypeList',
  props: {
    apartmentTypeList: {
      type: Array,
      required: true,
      default: function() {
        return {}
      }
    }
  },
  components: {
    VJsoneditor
  },
  data: function() {
    return {
      headers: [
        // {
        //   text: "APARTMENT TYPE",
        //   align: "left",
        //   sortable: true,
        //   value: "id"
        // },
        {
          text: 'APARTMENT TYPE',
          align: 'left',
          sortable: true,
          value: 'name'
        },

        { text: 'ORDER', align: 'left', sortable: true, value: 'order' },
        { text: 'ROOMS', align: 'left', sortable: true, value: 'rooms' },
        { text: 'AREA', align: 'left', sortable: true, value: 'area' },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ],
      editedIndex: -1,
      editedItem: {
        id: 0,
        name: '',
        buildingId: 0,
        rooms: 0,
        area: 0,
        order: null,
        properties: {}
      },
      defaultItem: {
        id: 0,
        name: '',
        buildingId: 0,
        rooms: 0,
        area: 0,
        order: null,
        properties: 0
      },
      dialog: false,
      mounted: false,
      stateOptions: {},
      search: ''
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? 'New Apartment Type'
        : 'Edit Apartment Type'
    }
    // apartmentList() {
    //   return this.$store.state.BuildingStore.buildings;
    // }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created: function() {
    //this.$store.dispatch("BuildingStore/fetchBuildings");
    this.stateOptions = localStorage.apartmentTypesListOptions
      ? JSON.parse(localStorage.apartmentTypesListOptions)
      : {}
  },
  mounted: function() {
    this.mounted = true
  },
  methods: {
    onApartmentTypeClick(apartmentType) {
      this.$router.push(
        '/masterplans/' +
          this.$route.params.masterplanId +
          '/buildings/' +
          this.$route.params.buildingId +
          '/apartmentTypes/' +
          apartmentType.id
      )
    },
    onUpdate(value) {
      if (this.mounted) {
        localStorage.apartmentTypesListOptions = JSON.stringify(value)
      }
    },
    // onBuildingClick(buildingId) {
    //   this.$router.push(
    //     "/masterplans/" +
    //       this.$route.params.masterplanId +
    //       "/buildings/" +
    //       buildingId
    //   );
    // },
    // handleApartmentTypeChange() {
    //   this.editedItem.apartmentTypeId = selectedApartmentType.id;
    //   this.editedItem.floor = selectedApartmentType.floor;
    //   this.editedItem.area = selectedApartmentType.area;
    // },
    editItem(item, e) {
      // e.stopPropagation()
      // this.editedIndex = this.apartmentTypeList.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialog = true
    },

    deleteItem(item, e) {
      e.stopPropagation()
      this.$store.dispatch('DialogStore/open', {
        title: 'Delete apartment type',
        header: false,
        subtitle: 'Are you sure?',
        okText: 'Ok',
        ok: () => {
          this.deleteItemAction(item)
        },
        cancelText: 'Cancel'
      })
    },
    deleteItemAction(item) {
      const index = this.apartmentTypeList.indexOf(item)
      this.$store
        .dispatch('ApartmentTypeStore/deleteApartmentType', item.id)
        .then(res => {
          this.$store.dispatch('ApartmentTypeStore/fetchApartmentTypes')
        })
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      if (this.editedIndex > -1) {
        //UPDATE
        //Object.assign(this.apartmentList[this.editedIndex], this.editedItem);
        this.$store
          .dispatch('ApartmentTypeStore/updateApartmentType', this.editedItem)

          .then(res => {
            this.$store.dispatch('ApartmentTypeStore/fetchApartmentTypes')
          })
      } else {
        //CREATE
        //this.apartmentList.push(this.editedItem);
        this.editedItem.buildingId = this.$store.state.BuildingStore.selectedBuilding.id
        this.$store
          .dispatch('ApartmentTypeStore/addApartmentType', this.editedItem)
          .then(res => {
            this.$store.dispatch('ApartmentTypeStore/fetchApartmentTypes')
          })
      }
      this.close()
    }
  }
}
</script>

<style scoped></style>
